import { PO_STATUS } from "./CONSTANTS";

export const getCancelPOStatusToSend = (poStatus) => {
    switch (poStatus) {
        case PO_STATUS.PENDING:
            return PO_STATUS.PENDING_CANCELLED;
        case PO_STATUS.DRAFT:
            return PO_STATUS.DRAFT_CANCELLED;
        default:
            return PO_STATUS.SOMS_CANCELLED;
    }
};